import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import Loading from "../../loader/loader.js";
import defaultProfileImg from "../../../../assets/img/Profile-Pitcher.png";

const Profile = ({ allUsersObject, profileloading, kycDetail }) => {
  return (
    <Card style={{ marginBottom: "10px" }}>
      <CardBody>
        <a href="#pablo" onClick={e => e.preventDefault()}>
          <img
            alt="..."
            className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
            // src={require("assets/img/theme/team-1.jpg")}
            src={kycDetail && kycDetail.selfieImageURL ? kycDetail && kycDetail.selfieImageURL : defaultProfileImg}
            style={{ width: "140px", height: "140px" }}
          />
        </a>
        <div className="pt-4 text-center">
          <h2 className="h2 title">
            {profileloading ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Loading style={{ width: "10px", height: "10px" }} />{" "}
              </div>
            ) : (
              <>
                <span className="d-block mb-1">{allUsersObject.fullName}</span>
                <small className="h3 font-weight-light text-muted">
                  {allUsersObject.companyName}
                </small>
              </>
            )}
          </h2>
        </div>
      </CardBody>
    </Card>
  );
};
export default Profile;
